export type FlagLoader = () => Promise<{default: string}>;
export const flagLoaders: Record<string, FlagLoader> = {
  ad: () => import('./images/flags/ad.svg'),
  ae: () => import('./images/flags/ae.svg'),
  af: () => import('./images/flags/af.svg'),
  ag: () => import('./images/flags/ag.svg'),
  ai: () => import('./images/flags/ai.svg'),
  al: () => import('./images/flags/al.svg'),
  am: () => import('./images/flags/am.svg'),
  ao: () => import('./images/flags/ao.svg'),
  aq: () => import('./images/flags/aq.svg'),
  ar: () => import('./images/flags/ar.svg'),
  as: () => import('./images/flags/as.svg'),
  at: () => import('./images/flags/at.svg'),
  au: () => import('./images/flags/au.svg'),
  aw: () => import('./images/flags/aw.svg'),
  ax: () => import('./images/flags/ax.svg'),
  az: () => import('./images/flags/az.svg'),
  ba: () => import('./images/flags/ba.svg'),
  bb: () => import('./images/flags/bb.svg'),
  bd: () => import('./images/flags/bd.svg'),
  be: () => import('./images/flags/be.svg'),
  bf: () => import('./images/flags/bf.svg'),
  bg: () => import('./images/flags/bg.svg'),
  bh: () => import('./images/flags/bh.svg'),
  bi: () => import('./images/flags/bi.svg'),
  bj: () => import('./images/flags/bj.svg'),
  bl: () => import('./images/flags/bl.svg'),
  bm: () => import('./images/flags/bm.svg'),
  bn: () => import('./images/flags/bn.svg'),
  bo: () => import('./images/flags/bo.svg'),
  bq: () => import('./images/flags/bq.svg'),
  br: () => import('./images/flags/br.svg'),
  bs: () => import('./images/flags/bs.svg'),
  bt: () => import('./images/flags/bt.svg'),
  bv: () => import('./images/flags/bv.svg'),
  bw: () => import('./images/flags/bw.svg'),
  by: () => import('./images/flags/by.svg'),
  bz: () => import('./images/flags/bz.svg'),
  ca: () => import('./images/flags/ca.svg'),
  cc: () => import('./images/flags/cc.svg'),
  cd: () => import('./images/flags/cd.svg'),
  cf: () => import('./images/flags/cf.svg'),
  cg: () => import('./images/flags/cg.svg'),
  ch: () => import('./images/flags/ch.svg'),
  ci: () => import('./images/flags/ci.svg'),
  ck: () => import('./images/flags/ck.svg'),
  cl: () => import('./images/flags/cl.svg'),
  cm: () => import('./images/flags/cm.svg'),
  cn: () => import('./images/flags/cn.svg'),
  co: () => import('./images/flags/co.svg'),
  cr: () => import('./images/flags/cr.svg'),
  cu: () => import('./images/flags/cu.svg'),
  cv: () => import('./images/flags/cv.svg'),
  cw: () => import('./images/flags/cw.svg'),
  cx: () => import('./images/flags/cx.svg'),
  cy: () => import('./images/flags/cy.svg'),
  cz: () => import('./images/flags/cz.svg'),
  de: () => import('./images/flags/de.svg'),
  dj: () => import('./images/flags/dj.svg'),
  dk: () => import('./images/flags/dk.svg'),
  dm: () => import('./images/flags/dm.svg'),
  do: () => import('./images/flags/do.svg'),
  dz: () => import('./images/flags/dz.svg'),
  ec: () => import('./images/flags/ec.svg'),
  ee: () => import('./images/flags/ee.svg'),
  eg: () => import('./images/flags/eg.svg'),
  eh: () => import('./images/flags/eh.svg'),
  er: () => import('./images/flags/er.svg'),
  es: () => import('./images/flags/es.svg'),
  et: () => import('./images/flags/et.svg'),
  fi: () => import('./images/flags/fi.svg'),
  fj: () => import('./images/flags/fj.svg'),
  fk: () => import('./images/flags/fk.svg'),
  fm: () => import('./images/flags/fm.svg'),
  fo: () => import('./images/flags/fo.svg'),
  fr: () => import('./images/flags/fr.svg'),
  ga: () => import('./images/flags/ga.svg'),
  gb_eng: () => import('./images/flags/gb-eng.svg'),
  gb_nir: () => import('./images/flags/gb-nir.svg'),
  gb_sct: () => import('./images/flags/gb-sct.svg'),
  gb_wls: () => import('./images/flags/gb-wls.svg'),
  gb: () => import('./images/flags/gb.svg'),
  gd: () => import('./images/flags/gd.svg'),
  ge: () => import('./images/flags/ge.svg'),
  gf: () => import('./images/flags/gf.svg'),
  gg: () => import('./images/flags/gg.svg'),
  gh: () => import('./images/flags/gh.svg'),
  gi: () => import('./images/flags/gi.svg'),
  gl: () => import('./images/flags/gl.svg'),
  gm: () => import('./images/flags/gm.svg'),
  gn: () => import('./images/flags/gn.svg'),
  gp: () => import('./images/flags/gp.svg'),
  gq: () => import('./images/flags/gq.svg'),
  gr: () => import('./images/flags/gr.svg'),
  gs: () => import('./images/flags/gs.svg'),
  gt: () => import('./images/flags/gt.svg'),
  gu: () => import('./images/flags/gu.svg'),
  gw: () => import('./images/flags/gw.svg'),
  gy: () => import('./images/flags/gy.svg'),
  hk: () => import('./images/flags/hk.svg'),
  hm: () => import('./images/flags/hm.svg'),
  hn: () => import('./images/flags/hn.svg'),
  hr: () => import('./images/flags/hr.svg'),
  ht: () => import('./images/flags/ht.svg'),
  hu: () => import('./images/flags/hu.svg'),
  id: () => import('./images/flags/id.svg'),
  ie: () => import('./images/flags/ie.svg'),
  il: () => import('./images/flags/il.svg'),
  im: () => import('./images/flags/im.svg'),
  in: () => import('./images/flags/in.svg'),
  io: () => import('./images/flags/io.svg'),
  iq: () => import('./images/flags/iq.svg'),
  ir: () => import('./images/flags/ir.svg'),
  is: () => import('./images/flags/is.svg'),
  it: () => import('./images/flags/it.svg'),
  je: () => import('./images/flags/je.svg'),
  jm: () => import('./images/flags/jm.svg'),
  jo: () => import('./images/flags/jo.svg'),
  jp: () => import('./images/flags/jp.svg'),
  ke: () => import('./images/flags/ke.svg'),
  kg: () => import('./images/flags/kg.svg'),
  kh: () => import('./images/flags/kh.svg'),
  ki: () => import('./images/flags/ki.svg'),
  km: () => import('./images/flags/km.svg'),
  kn: () => import('./images/flags/kn.svg'),
  kp: () => import('./images/flags/kp.svg'),
  kr: () => import('./images/flags/kr.svg'),
  kw: () => import('./images/flags/kw.svg'),
  ky: () => import('./images/flags/ky.svg'),
  kz: () => import('./images/flags/kz.svg'),
  la: () => import('./images/flags/la.svg'),
  lb: () => import('./images/flags/lb.svg'),
  lc: () => import('./images/flags/lc.svg'),
  li: () => import('./images/flags/li.svg'),
  lk: () => import('./images/flags/lk.svg'),
  lr: () => import('./images/flags/lr.svg'),
  ls: () => import('./images/flags/ls.svg'),
  lt: () => import('./images/flags/lt.svg'),
  lu: () => import('./images/flags/lu.svg'),
  lv: () => import('./images/flags/lv.svg'),
  ly: () => import('./images/flags/ly.svg'),
  ma: () => import('./images/flags/ma.svg'),
  mc: () => import('./images/flags/mc.svg'),
  md: () => import('./images/flags/md.svg'),
  me: () => import('./images/flags/me.svg'),
  mf: () => import('./images/flags/mf.svg'),
  mg: () => import('./images/flags/mg.svg'),
  mh: () => import('./images/flags/mh.svg'),
  mk: () => import('./images/flags/mk.svg'),
  ml: () => import('./images/flags/ml.svg'),
  mm: () => import('./images/flags/mm.svg'),
  mn: () => import('./images/flags/mn.svg'),
  mo: () => import('./images/flags/mo.svg'),
  mp: () => import('./images/flags/mp.svg'),
  mq: () => import('./images/flags/mq.svg'),
  mr: () => import('./images/flags/mr.svg'),
  ms: () => import('./images/flags/ms.svg'),
  mt: () => import('./images/flags/mt.svg'),
  mu: () => import('./images/flags/mu.svg'),
  mv: () => import('./images/flags/mv.svg'),
  mw: () => import('./images/flags/mw.svg'),
  mx: () => import('./images/flags/mx.svg'),
  my: () => import('./images/flags/my.svg'),
  mz: () => import('./images/flags/mz.svg'),
  na: () => import('./images/flags/na.svg'),
  nc: () => import('./images/flags/nc.svg'),
  ne: () => import('./images/flags/ne.svg'),
  nf: () => import('./images/flags/nf.svg'),
  ng: () => import('./images/flags/ng.svg'),
  ni: () => import('./images/flags/ni.svg'),
  nl: () => import('./images/flags/nl.svg'),
  no: () => import('./images/flags/no.svg'),
  np: () => import('./images/flags/np.svg'),
  nr: () => import('./images/flags/nr.svg'),
  nu: () => import('./images/flags/nu.svg'),
  nz: () => import('./images/flags/nz.svg'),
  om: () => import('./images/flags/om.svg'),
  pa: () => import('./images/flags/pa.svg'),
  pe: () => import('./images/flags/pe.svg'),
  pf: () => import('./images/flags/pf.svg'),
  pg: () => import('./images/flags/pg.svg'),
  ph: () => import('./images/flags/ph.svg'),
  pk: () => import('./images/flags/pk.svg'),
  pl: () => import('./images/flags/pl.svg'),
  pm: () => import('./images/flags/pm.svg'),
  pn: () => import('./images/flags/pn.svg'),
  pr: () => import('./images/flags/pr.svg'),
  ps: () => import('./images/flags/ps.svg'),
  pt: () => import('./images/flags/pt.svg'),
  pw: () => import('./images/flags/pw.svg'),
  py: () => import('./images/flags/py.svg'),
  qa: () => import('./images/flags/qa.svg'),
  re: () => import('./images/flags/re.svg'),
  ro: () => import('./images/flags/ro.svg'),
  rs: () => import('./images/flags/rs.svg'),
  ru: () => import('./images/flags/ru.svg'),
  rw: () => import('./images/flags/rw.svg'),
  sa: () => import('./images/flags/sa.svg'),
  sb: () => import('./images/flags/sb.svg'),
  sc: () => import('./images/flags/sc.svg'),
  sd: () => import('./images/flags/sd.svg'),
  se: () => import('./images/flags/se.svg'),
  sg: () => import('./images/flags/sg.svg'),
  sh: () => import('./images/flags/sh.svg'),
  si: () => import('./images/flags/si.svg'),
  sj: () => import('./images/flags/sj.svg'),
  sk: () => import('./images/flags/sk.svg'),
  sl: () => import('./images/flags/sl.svg'),
  sm: () => import('./images/flags/sm.svg'),
  sn: () => import('./images/flags/sn.svg'),
  so: () => import('./images/flags/so.svg'),
  sr: () => import('./images/flags/sr.svg'),
  ss: () => import('./images/flags/ss.svg'),
  st: () => import('./images/flags/st.svg'),
  sv: () => import('./images/flags/sv.svg'),
  sx: () => import('./images/flags/sx.svg'),
  sy: () => import('./images/flags/sy.svg'),
  sz: () => import('./images/flags/sz.svg'),
  tc: () => import('./images/flags/tc.svg'),
  td: () => import('./images/flags/td.svg'),
  tf: () => import('./images/flags/tf.svg'),
  tg: () => import('./images/flags/tg.svg'),
  th: () => import('./images/flags/th.svg'),
  tj: () => import('./images/flags/tj.svg'),
  tk: () => import('./images/flags/tk.svg'),
  tl: () => import('./images/flags/tl.svg'),
  tm: () => import('./images/flags/tm.svg'),
  tn: () => import('./images/flags/tn.svg'),
  to: () => import('./images/flags/to.svg'),
  tr: () => import('./images/flags/tr.svg'),
  tt: () => import('./images/flags/tt.svg'),
  tv: () => import('./images/flags/tv.svg'),
  tw: () => import('./images/flags/tw.svg'),
  tz: () => import('./images/flags/tz.svg'),
  ua: () => import('./images/flags/ua.svg'),
  ug: () => import('./images/flags/ug.svg'),
  um: () => import('./images/flags/um.svg'),
  us: () => import('./images/flags/us.svg'),
  uy: () => import('./images/flags/uy.svg'),
  uz: () => import('./images/flags/uz.svg'),
  va: () => import('./images/flags/va.svg'),
  vc: () => import('./images/flags/vc.svg'),
  ve: () => import('./images/flags/ve.svg'),
  vg: () => import('./images/flags/vg.svg'),
  vi: () => import('./images/flags/vi.svg'),
  vn: () => import('./images/flags/vn.svg'),
  vu: () => import('./images/flags/vu.svg'),
  wf: () => import('./images/flags/wf.svg'),
  ws: () => import('./images/flags/ws.svg'),
  xk: () => import('./images/flags/xk.svg'),
  ye: () => import('./images/flags/ye.svg'),
  yt: () => import('./images/flags/yt.svg'),
  za: () => import('./images/flags/za.svg'),
  zm: () => import('./images/flags/zm.svg'),
  zw: () => import('./images/flags/zw.svg')
};
